export default {
  'PROJECT ID': {
    field: 'proId',
    multiple: false,
    required: true,
  },
  NAME: {
    field: 'name',
    multiple: false,
    required: true,
  },
  MEMBERS: {
    field: 'email',
    multiple: false,
  },
  'JOBSITE NAME': {
    field: 'jobsiteName',
    multiple: false,
    required: true,
  },
  STREET: {
    field: 'street',
    multiple: false,
    required: true,
  },
  CITY: {
    field: 'city',
    multiple: false,
    required: true,
  },
  STATE: {
    field: 'state',
    multiple: false,
    required: true,
  },
  ZIP: {
    field: 'zipcode',
    multiple: false,
    required: true,
  },
  'PROJECT INVENTORY LOCATION': {
    field: 'projInvLoc',
    multiple: false,
    required: true,
  },
};
